<template>
  <component :is="item.value instanceof Object ? 'div' : 'span'">
    <template v-if="item.value instanceof Object && item.value.template">
      <div :class="item.class" :style="item.styles">
        <div :class="`custom-label ${item.labelClass}`" :style="labelStyles"><h6>{{ item.key }}</h6><span v-if="item.showColon" class="custom-colon">:</span></div>
        <div :class="`custom-value ${item.valueClass}`" :style="item.valueStyles"><component :is="item.value" :item="item.item"></component></div>
      </div>
    </template>
    <template v-else>
      <div :class="item.class" :style="item.styles">
        <div :class="`custom-label ${item.labelClass}`" :style="labelStyles">
          <h4 v-if="item.title">{{ item.key }}</h4>
          <h5 v-else-if="item.subtitle">{{ item.key }}</h5>
          <b style="font-weight: 600" v-else>{{ item.key }}</b>
          <span v-if="item.showColon" class="custom-colon">:</span>
        </div>
        <div v-if="item.value" :class="`custom-value ${item.valueClass}`">
          <span :style="item.valueStyles">{{ item.value }}</span>
        </div>
      </div>
    </template>
  </component>
</template>

<script>
export default {
  props: {
    item: Object
  },
  data() {
    return {
      labelStyles: {
        display: 'flex',
        justifyContent: 'space-between',
        ...this.item.labelStyles,
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-colon {
  display: none;
}
@media (max-width: 677px) {
  .row {
    .custom-value.text-end {
      text-align: left !important;
    }
  }
}
@media (min-width: 678px) {
  .custom-colon {
    display: inline;
  }
}
</style>